import { formatEntity, entitiesTemplates } from '../../dependencies';
import types from './types';

export const fetchExpenseTriggerRequest = id => ({
    type: types.FETCH_EXPENSE_TRIGGER_REQUEST,
    meta: { id },
});

export const fetchExpenseTriggerSuccess = (id, payload) => ({
    type: types.FETCH_EXPENSE_TRIGGER_SUCCESS,
    meta: { id },
    payload: formatEntity({
        entity: payload,
        template: entitiesTemplates.expenseTrigger,
    }),
});

export const fetchExpenseTriggerFailure = (id, error) => ({
    type: types.FETCH_EXPENSE_TRIGGER_FAILURE,
    meta: { id },
    error,
});

export const fetchExpenseTriggerInvalidate = id => ({
    type: types.FETCH_EXPENSE_TRIGGER_CANCEL,
    meta: { id },
});
